import React from 'react';
export const CardSkeleton: React.FC = () => {
  return <div className="bg-white dark:bg-gradient-to-b dark:from-[#0f0c29] dark:to-[#302b63] rounded-lg border border-purple-200/50 dark:border-indigo-500/30 p-5 shadow-sm dark:shadow-[0_0_15px_rgba(138,43,226,0.2)] backdrop-blur-sm relative overflow-hidden" data-id="element-21022">
      {/* Animated shimmer effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-purple-200/20 dark:via-indigo-500/10 to-transparent skeleton-shimmer" data-id="element-21023"></div>
      <div className="relative" data-id="element-21024">
        <div className="flex items-center justify-between mb-4" data-id="element-21025">
          <div className="h-6 w-32 bg-gray-200 dark:bg-indigo-700/50 rounded animate-pulse" data-id="element-21026"></div>
        </div>
        <div className="space-y-3" data-id="element-21027">
          <div className="h-20 bg-gray-100 dark:bg-indigo-800/30 rounded animate-pulse" data-id="element-21028"></div>
          <div className="grid grid-cols-2 gap-2" data-id="element-21029">
            <div className="h-12 bg-gray-100 dark:bg-indigo-800/30 rounded animate-pulse" data-id="element-21030"></div>
            <div className="h-12 bg-gray-100 dark:bg-indigo-800/30 rounded animate-pulse" data-id="element-21031"></div>
          </div>
          <div className="h-16 bg-gray-100 dark:bg-indigo-800/30 rounded animate-pulse" data-id="element-21032"></div>
          <div className="h-10 bg-gray-100 dark:bg-indigo-800/30 rounded animate-pulse" data-id="element-21033"></div>
        </div>
      </div>
    </div>;
};